export const SourceTypeEnumText =
{
    SLCQuestionnaire: "SLCQuestionnaire",
    StorylineQuestionnaire: "StorylineQuestionnaire",
    IDE: "IDE",
    SLCReflection: "SLCReflection",
}